<template>
	<div class="settings">
		<div class="title">Settings</div>
		
		<div class="rows">
			<div class="row" v-hammer:tap="() => edit('audio', !app.config.audio)">
				<div class="label">Audio</div>
				<div class="value">{{ audio_value }}</div>
			</div>
			<div class="row" v-hammer:tap="() => edit('quick_battle', !app.config.quick_battle)">
				<div class="label">Battle speed</div>
				<div class="value">{{ quick_battle_value }}</div>
			</div>
		</div>

		<div class="button" v-hammer:tap="() => close()">Close</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sounds from '@/js/sounds'

export default {
	name: 'settings',
	data() {
		return {
			audio: true
		}
	},
	computed: {
		...mapGetters([ 'app' ]),
		audio_value() {
			if (this.app.config.audio) return "Yes"
			return "No"
		},
		quick_battle_value() {
			if (this.app.config.quick_battle) return "Fast"
			return "Normal"
		}
	},
	methods: {
		edit(key, value) {
			let s = {}
			s[key] = value
			Sounds.play('button')
			this.$store.dispatch('edit_config', s)
		},
		close() {
			Sounds.play('button')
			this.$store.commit('EDIT_APP_STATE', { settings: false })
		}
	}
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'

.settings
	absolute 0
	background-color dark
	flex center center
	flex-direction column
	text-align center
	transition 0.25s easeOutQuart
	&.settings-enter, &.settings-leave-to
		opacity 0
		transform translateY(-24px)
	.title
		margin 0 0 40px 0
		font-size 6.4rem
	.rows
		width 100%
		margin 0 0 80px 0
		.row
			width 280px
			height 48px
			margin 0 auto 16px auto
			padding 0 0 0 16px
			border-radius 8px
			overflow hidden
			background-color darken(dark, 25%)
			line-height (@height + 4px)
			flex center center
			text-align left
			white-space nowrap
			cursor pointer
			&:hover
				.value
					background-color darken(light, 10%)
			.label
				display inline-block
				height 100%
				width calc(100% - 96px)
			.value
				display inline-block
				width 96px
				height 100%
				background-color light
				color dark
				text-align center
	.button
		height 64px
		padding 0 32px
		background-color light
		color dark
		padding-top 2px
		flex center center
		font-weight 700
		cursor pointer
		&:hover
			animation none
			background-color darken(light, 10%)
		&:active
			animation none
			background-color darken(light, 10%)
			transform translateY(2px)


</style>
